<template>
    <header>
        <router-link class="logo" :title="'Home - Trim Editor v' + appVersion" :to="'/'">
            <img :src="`${publicPath}imgs/DST logo small.png`" alt="DST Logo small">
        </router-link>

        <div class="v-divider"></div>

        <UndoRedo :disabled="trimEditDisabled"></UndoRedo>

        <div class="v-divider"></div>

        <ZoomControls></ZoomControls>

        <div class="v-divider"></div>

        <div class="flex">
            <CenterTrimOnCanvas :disabled="trimEditDisabled"></CenterTrimOnCanvas>
        </div>

        <RotateTrim :defaultAngle="5" :disabled="trimEditDisabled"></RotateTrim>

        <div class="v-divider"></div>

        <div class="flex">
            <SnapToGrid :disabled="trimEditDisabled"></SnapToGrid>

            <GridDisplay></GridDisplay>
        </div>

        <div class="split"></div>

        <template v-if="hasUserAccess">
            <EditTrimInfo :disabled="trimEditDisabled"></EditTrimInfo>

            <DuplicateTrim></DuplicateTrim>

            <CreateNewTrim></CreateNewTrim>

            <SaveTrim :buttonType="'ButtonCircle'"></SaveTrim>
        </template>

        <ExportTrim :disabled="trimEditDisabled && !hasAdminAccess"></ExportTrim>

        <UserCabinet :typeSmall="true"></UserCabinet>
    </header>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import UndoRedo from './UndoRedo';
    import CenterTrimOnCanvas from "./CenterTrimOnCanvas";
    import SnapToGrid from "./SnapToGrid";
    import GridDisplay from "./GridDisplay";
    import RotateTrim from "./RotateTrim";
    import ZoomControls from "./ZoomControls";
    import SaveTrim from "./SaveTrim";
    import DuplicateTrim from "./DuplicateTrim";
    import CreateNewTrim from "./CreateNewTrim";
    import EditTrimInfo from "./EditTrimInfo";
    import ExportTrim from "./ExportTrim";
    import UserCabinet from "../../authentication/userCabinet/UserCabinet";

    export default {
        name: "EditorHeader",

        components: {
            UserCabinet,
            ExportTrim,
            EditTrimInfo,
            CreateNewTrim,
            DuplicateTrim,
            SaveTrim,
            ZoomControls,
            RotateTrim,
            GridDisplay,
            SnapToGrid,
            CenterTrimOnCanvas,
            UndoRedo,
        },
        
        computed: {
            ...mapState([
                'publicPath',
                'appVersion',
            ]),

            ...mapGetters('editor', [
                'trimEditDisabled',
            ]),

            ...mapGetters('authentication', [
                'hasUserAccess',
                'hasAdminAccess',
                'isOnlinePortalUser',
            ]),
            
        },

    }
</script>

<style scoped>
    header {
        display: flex;
        justify-content: flex-start;
        padding: 8px;
        border-bottom: 1px solid #ccc
    }

    .flex {
        align-items: center;
    }

    .logo {
        padding: 0 7px;
    }

    .logo img {
        width: 30px;
        vertical-align: middle;
    }

    .v-divider {
        height: 100%;
        margin: 0 5px;
        border-left: 1px solid #ddd;
    }

    .split {
        margin-left: auto;
    }

    .button {
        padding: 8px 10px;
        font-size: 14px;
    }

    button {
        margin: 0 5px;
    }
</style>